/*
 * @Author: liuzongwan
 * @Date: 2024-02-21 14:26:13
 * @LastEditTime: 2026-01-17 16:51:00
 * @LastEditor: zhangkun
 * @Description:
 */

import { httpClient } from "@/assets/js/http";
import urls from "@/api/urls";
import constant from "@/constant";

/* 记录日志 */
function addUserBehavior(data = {}) {
    return httpClient.post(urls.addUserBehavior, data);
}

/* 留痕-其他行为 */
function commonLeaveTracesLog(that, obj = {}) {
    if (!obj.eventid) return;
    try {
        const info = JSON.parse(sessionStorage.getItem("_user") || "{}");
        const tracesLog = {
            en_mobileno: info.en_mobileno || undefined,
            eventid: "",
            eventname: "",
            eventtype: "",
            eventversion: "",
            nowpath: that.$route.path,
            opertime: that.$util.get14DigitTimestamp(),
            phonemodel: "PC",
            webversion: "",
            ...obj
        };
        delete tracesLog.pdfBase64;
        return httpClient.post(urls.leaveTracesLog, {
            tracesLogList: [tracesLog]
        });
    } catch (e) {
        console.error(e);
    }
}
function commonLeaveTracesLogs(that, list = []) {
    try {
        const info = JSON.parse(sessionStorage.getItem("_user") || "{}");
        const resList = list
            .map((item) => {
                delete item.pdfBase64;
                return {
                    en_mobileno: info.en_mobileno || undefined,
                    eventid: "",
                    eventname: "",
                    eventtype: "",
                    eventversion: "",
                    nowpath: that.$route.path,
                    opertime: that.$util.get14DigitTimestamp(),
                    phonemodel: "PC",
                    webversion: "",
                    ...item
                };
            })
            .filter((item) => item.eventid);
        if (resList.length === 0) return;
        return httpClient.post(urls.leaveTracesLog, {
            tracesLogList: resList
        });
    } catch (e) {
        console.error(e);
    }
}

/* 留痕-协议 */
function agreementLeaveTracesLog(that, obj = {}, list) {
    if (!obj.eventid) return;
    try {
        const info = JSON.parse(sessionStorage.getItem("_user") || "{}");
        const tracesLog = {
            en_mobileno: info.en_mobileno || undefined,
            eventid: "",
            eventname: "",
            eventtype: "",
            eventversion: "",
            nowpath: that.$route.path,
            opertime: that.$util.get14DigitTimestamp(),
            phonemodel: "PC",
            webversion: "",
            ...obj
        };
        let logs = [];
        if (list.length > 0) {
            logs = (list || [tracesLog]).map((item) => {
                delete item.pdfBase64;
                return {
                    content: JSON.stringify({
                        policyid: item.id || "",
                        policyname: item.title || "",
                        policytype: item.policytype || "",
                        policyversion: item.policyversion || "",
                        ...item
                    }),
                    ...tracesLog,
                    eventid:
                        item.querytype &&
                        tracesLog.eventid === constant.RECORD.cms_protocol_agreement_agree
                            ? tracesLog.eventid + "/" + item.querytype
                            : tracesLog.eventid,
                    eventversion: item.policyversion || "", // 协议版本
                    eventtype: item.policytype || "",
                    articleid: item.articleid || item.id // 文章ID
                };
            });
        } else {
            logs.push(tracesLog);
        }
        return httpClient.post(urls.leaveTracesLog, {
            tracesLogList: logs
        });
    } catch (e) {
        console.error(e);
    }
}
function fundFileLeaveTracesLog(that, readFileInfoList = [], fundcode) {
    try {
        commonLeaveTracesLogs(
            that,
            readFileInfoList.map((item) => {
                // 创建新的content对象，排除pdfBase64属性
                const content = { ...item };
                delete content.pdfBase64; // 安全删除pdfBase64属性
                return {
                    eventid:
                        that.$const.RECORD.cms_fund_agreement_agree +
                        "/" +
                        (fundcode || item.fundcode),
                    eventname: `协议同意`,
                    content: content
                };
            })
        );
    } catch {
        console.error("产品文件留痕失败");
    }
}

/* 查询广告 */
function getBannerAds(data = {}) {
    return httpClient.post(urls.bannerAds, { ...data, status: "3" });
}

/* 查询业务是否需要验证交易密码 */
function queryValidPwdTrdMethod(data = {}) {
    return httpClient.post(urls.queryValidPwdTrdMethod, data);
}

// 身份证ocr
function ocr(data = {}) {
    return httpClient.post(urls.ocr, data);
}

// 外国永久居住身份证ocr
function fOcr(data = {}) {
    return httpClient.post(urls.fOcr, data);
}

/* 查询是否需要脱敏 */
function queryDesensitization(data = {}) {
    return httpClient.post(urls.queryDesensitization, data);
}

export default {
    addUserBehavior,
    commonLeaveTracesLog,
    commonLeaveTracesLogs,
    agreementLeaveTracesLog,
    fundFileLeaveTracesLog,
    getBannerAds,
    queryValidPwdTrdMethod,
    ocr,
    fOcr,
    queryDesensitization
};
